import { render, staticRenderFns } from "./FAQ-Box.vue?vue&type=template&id=3dfc82a5&scoped=true"
import script from "./FAQ-Box.vue?vue&type=script&lang=js"
export * from "./FAQ-Box.vue?vue&type=script&lang=js"
import style0 from "./FAQ-Box.vue?vue&type=style&index=0&id=3dfc82a5&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfc82a5",
  null
  
)

export default component.exports